import { useState } from "react";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import { withSnackbar } from "notistack";
import { v4 as uuidv4 } from "uuid";

import AlertDialog from "./../../common/AlertDialog";

const UsersTable = (props) => {
  const [openDeleteConfirmationDialogue, setOpenDeleteConfirmationDialogue] =
    useState(false);

  const handleCloseDeleteConfirmationDialogue = () => {
      setOpenDeleteConfirmationDialogue(false);
  };

  const handleEditUser = (data) => {
    props.handleOpenEditUserForm(data);
  };

  const handleDeleteUserClick = (data) => {
    props.handleSetContextUser(data);
    setOpenDeleteConfirmationDialogue(true);
  };

  const handleDeleteUser = () => {
    handleCloseDeleteConfirmationDialogue();
    props.handleDelete();
  };

  return (
    <TableContainer component={Paper}>
      <Table stickyHeader>
        <TableHead sx = {{cursor:'default'}}>
          <TableRow>
            <TableCell align="left">FirstName</TableCell>
            <TableCell align="left">LastName</TableCell>
            <TableCell align="right">UserName</TableCell>
            <TableCell align="right">Branch</TableCell>
            <TableCell align="right">Role</TableCell>
            <TableCell align="right" />
          </TableRow>
        </TableHead>

        <TableBody>
          {props.users.map((user) => (
            <TableRow hover key={uuidv4()}>
              <TableCell style={{ width: "auto" }} align="left">
                {user.FirstName}
              </TableCell>
              <TableCell style={{ width: "auto" }} align="left">
                {user.LastName}
              </TableCell>
              <TableCell style={{ width: "auto" }} align="right">
                {user.UserName}
              </TableCell>
              <TableCell style={{ width: "auto" }} align="right">
                {user.Branch}
              </TableCell>
              <TableCell style={{ width: "auto" }} align="right">
                {user.Role}
              </TableCell>
              <TableCell style={{ width: "auto" }} align="right">
                <IconButton
                  onClick={() => handleEditUser(user)}
                  color="secondary"
                  edge="start"
                >
                  <EditIcon />
                </IconButton>
                <IconButton
                  onClick={() => handleDeleteUserClick(user)}
                  color="primary"
                  edge="end"
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <AlertDialog
        open={openDeleteConfirmationDialogue}
        message={`Remove ${props.user.FirstName} from users list ?`}
        handleClose={handleCloseDeleteConfirmationDialogue}
        handleDelete={handleDeleteUser}
      />
    </TableContainer>
  );
};

export default withSnackbar(UsersTable);
